import BaseService from './BaseService'
import UserModel from '../models/UserModel'
import AccountsModel from '../models/AccountsModel'
// import UserUsersModel from '../models/UserUserModel'
import FileModel from "@/models/FileModel";
import RelationshipFileModel from "../models/RelationshipFileModel";
import GroupModel from '../models/GroupModel'
import GroupUserModel from '../models/GroupUserModel'
import NotificationsModel from '../models/NotificationsModel'
import NotificationsLangModel from '../models/NotificationsLangModel'
import ControllerModel from '../models/ControllerModel'
import NotificationUsersModel from '../models/NotificationUsersModel';
import CountryModel from '../models/CountryModel';
import StateModel from '../models/StateModel';
import LangModel from '../models/LangModel';
import SettingsModel from '../models/SettingsModel';
import UserFamilyModel from "@/models/UserFamilyModel";
import AdminModel from "../models/AdminModel";
import RoleAdminPropertyModel from "../models/RoleAdminPropertyModel";
import UserAdminModel from '../models/UserAdminModel';


import ShowroomsModel from '../models/ShowroomModel';
import ColorModel from '../models/ColorModel';
import RentalOrderCustomModel from '../models/RentalOrderCustomModel';
import VehicleCategoryModel from '../models/VehicleCategoryModel';
import SetuptermModel from '../models/SetUpTermModel';
//import LoyaltyLevelModel from '../models/LoyaltyLevelModel';
import NeedToPay from '../models/PaymentHistoryModel';
import PaymentHistoryOrderModel from '../models/PaymentHistoryOrderModel';
import TermOfUserPolicyModel from '../models/TermOfUserPolicyModel';
import TermOfUserLangModel from '../models/TermOfUseLang';
import RentalOrderModel from '../models/RentalOrderModel';
import CarForSellModel from '../models/CarForSellModel';
import CarCommonModel from '../models/CarCommonModel';
import VoucherModel from '../models/VoucherModel';
import UseVoucherModel from '../models/UseVoucherModel';
import VoucherCustomerModel from  '../models/VoucherCustomerModel';
import VoucherLoyaltyModel from  '../models/VoucherLoyaltyModel';
import VoucherVehicleCategoryModel from  '../models/VoucherVehicleCategoryModel';
import LoyaltyLevelModel from  '../models/LoyaltyLevelModel';
import CarForRentModel from '../models/CarForRentModel';
import OtherCostModel from '../models/OtherCostModel';     




import RentalOrderSellModel from '../models/RentalOrderSellModel';
import DashboardModel from '../models/DashBoardModel';
import AvailableForRentModel from '../models/AvailableForRentModel';
import BannerModel from '../models/BannerModel';
import NewsCategoryModel from '../models/NewsCategoryModel';
import NewsProductModel from '../models/NewsProductModel';
import NewsModel from '../models/NewsModel';
import PointHistoryModel from '../models/PointHistoryModel';
import VisitModel from '../models/VisitModel';
import RatingModel from '../models/RatingModel';
import RentalOrderTermModel from '../models/RentalOrderTermModel';
import ReferredHistoryModel from '../models/ReferredHistoryModel';
import ChatModel from '../models/ChatModel';

import FAQsModel from '../models/FAQsModel';
import RentalOrderRentModel from '../models/RentalOrderRentModel';
import ReviewsModel from '../models/ReviewsModel';
import CareReminderModel from '../models/CareReminderModel';
import CarAccidentModel from '../models/CarAccidentModel';




export default {
  services: {
    'car_accident': {
      'model': new CarAccidentModel(),
      'service': new BaseService(new CarAccidentModel())
    },
    'care_reminder': {
      'model': new CareReminderModel(),
      'service': new BaseService(new CareReminderModel())
    },
    'reviews': {
      'model': new ReviewsModel(),
      'service': new BaseService(new ReviewsModel())
    },
    'rental_order_rent': {
      'model': new RentalOrderRentModel(),
      'service': new BaseService(new RentalOrderRentModel())
    },
    'faqs': {
      'model': new FAQsModel(),
      'service': new BaseService(new FAQsModel())
    },
    'othercost': {
      'model': new OtherCostModel(),
      'service': new BaseService(new OtherCostModel())
    },
    'rental_order_term': {
      'model': new RentalOrderTermModel(),
      'service': new BaseService(new RentalOrderTermModel())
    },
    'rate': {
      'model': new RatingModel(),
      'service': new BaseService(new RatingModel())
    },
    'rental_order_buy': {
      'model': new VisitModel(),
      'service': new BaseService(new VisitModel())
    },
    'available_for_rent': {
      'model': new AvailableForRentModel(),
      'service': new BaseService(new AvailableForRentModel())
    },
    'dashboard': {
      'model': new DashboardModel(),
      'service': new BaseService(new DashboardModel())
    },
    'rental_order_custom': {
      'model': new RentalOrderCustomModel(),
      'service': new BaseService(new RentalOrderCustomModel())
    },
    'rental_order_sell': {
      'model': new RentalOrderSellModel(),
      'service': new BaseService(new RentalOrderSellModel())
    },
    'car_for_rent': {
      'model': new CarForRentModel(),
      'service': new BaseService(new CarForRentModel())
    },
    'loyalty_level': {
      'model': new LoyaltyLevelModel(),
      'service': new BaseService(new LoyaltyLevelModel())
    },
    'voucher': {
      'model': new VoucherModel(),
      'service': new BaseService(new VoucherModel())
    },
    'voucher_vehicle_category': {
      'model': new VoucherVehicleCategoryModel(),
      'service': new BaseService(new VoucherVehicleCategoryModel())
    },
    'voucher_loyalty': {
      'model': new VoucherLoyaltyModel(),
      'service': new BaseService(new VoucherLoyaltyModel())
    },
    'use_voucher': {
      'model': new UseVoucherModel(),
      'service': new BaseService(new UseVoucherModel())
    },
    'voucher_customer': {
      'model': new VoucherCustomerModel(),
      'service': new BaseService(new VoucherCustomerModel())
    },
    'vehicle_category': {
      'model': new VehicleCategoryModel(),
      'service': new BaseService(new VehicleCategoryModel())
    },
   /* 'loyalty_level': {
      'model': new LoyaltyLevelModel(),
      'service': new BaseService(new LoyaltyLevelModel())
    },*/
    'set_up_term': {
      'model': new SetuptermModel(),
      'service': new BaseService(new SetuptermModel())
    },
    'payment_history': {
      'model': new NeedToPay(),
      'service': new BaseService(new NeedToPay())
    },
    'payment_history_order': {
      'model': new PaymentHistoryOrderModel(),
      'service': new BaseService(new PaymentHistoryOrderModel())
    },
    'term_of_use': {
      'model': new TermOfUserPolicyModel(),
      'service': new BaseService(new TermOfUserPolicyModel())
    },
    'term_of_use_lang': {
      'model': new TermOfUserLangModel(),
      'service': new BaseService(new TermOfUserLangModel())
    },
    'rental_order': {
      'model': new RentalOrderModel(),
      'service': new BaseService(new RentalOrderModel())
    },
    'car_for_sell': {
      'model': new CarForSellModel(),
      'service': new BaseService(new CarForSellModel())
    },
    'color': {
      'model': new ColorModel(),
      'service': new BaseService(new ColorModel())
    },
    'showrooms': {
      'model': new ShowroomsModel(),
      'service': new BaseService(new ShowroomsModel())
    },
    'car_common': {
      'model': new CarCommonModel(),
      'service': new BaseService(new CarCommonModel())
    },

    'user_admin': {
      'model': new UserAdminModel(),
      'service': new BaseService(new UserAdminModel())
    },
    'role_admin_property': {
      'model': new RoleAdminPropertyModel(),
      'service': new BaseService(new RoleAdminPropertyModel())
    },
    'view_admin': {
      'model': new AdminModel(),
      'service': new BaseService(new AdminModel())
    },
    'user_family': {
      'model': new UserFamilyModel(),
      'service': new BaseService(new UserFamilyModel())
    },
    'setting': {
      'model': new SettingsModel(),
      'service': new BaseService(new SettingsModel())
    },
    'lang': {
      'model': new LangModel(),
      'service': new BaseService(new LangModel())
    },
    'country': {
      'model': new CountryModel(),
      'service': new BaseService(new CountryModel())
    },
    'state': {
      'model': new StateModel(),
      'service': new BaseService(new StateModel())
    },
    'accounts': {
      'model': new AccountsModel(),
      'service': new BaseService(new AccountsModel())
    },
    'group': {
      'model': new GroupModel(),
      'service': new BaseService(new GroupModel())
    },
    'group_user': {
      'model': new GroupUserModel(),
      'service': new BaseService(new GroupUserModel())
    },
    'users': {
      'model': new UserModel(),
      'service': new BaseService(new UserModel())
    },
    'file': {
      'model': new FileModel(),
      'service': new BaseService(new FileModel())
    },
    'relationship_file': {
      'model': new RelationshipFileModel(),
      'service': new BaseService(new RelationshipFileModel())
    },

    'notification': {
      'service': new BaseService(new NotificationsModel()),
      'model': new NotificationsModel(),
      'rels': [],
    },

    'lang_notification': {
      'service': new BaseService(new NotificationsLangModel()),
      'model': new NotificationsLangModel()
    },
    'controller': {
      'service': new BaseService(new ControllerModel()),
      'model': new ControllerModel()
    },
    'notification_users': {
      'service': new BaseService(new NotificationUsersModel()),
      'model': new NotificationUsersModel()
    },
    'banner': {
      'model': new BannerModel(),
      'service': new BaseService(new BannerModel())
    },
    'chat': {
      'model': new ChatModel(),
      'service': new BaseService(new ChatModel())
    },
    'news_category': {
      'model': new NewsCategoryModel(),
      'service': new BaseService(new NewsCategoryModel())
    },
    'news_product': {
      'model': new NewsProductModel(),
      'service': new BaseService(new NewsProductModel())
    },
    'news': {
      'model': new NewsModel(),
      'service': new BaseService(new NewsModel())
    },
    'point_history': {
      'model': new PointHistoryModel(),
      'service': new BaseService(new PointHistoryModel())
    },
    'referred_history': {
      'model': new ReferredHistoryModel(),
      'service': new BaseService(new ReferredHistoryModel())
    },
  },
  getModel(modelName) {
    console.log("model name la : " + modelName)
    return this.services[modelName].model
  },
  getList(modelName, params) {
    return this.services[modelName].service.getListQuery(params);
  },
  countData(modelName) {
    return this.services[modelName].service.countDataQuery();
  },
  updateData(modelName) {
    console.log("updateData:", modelName)
    return this.services[modelName].service.updateDataQuery();

  },
  insertData(modelName) {
    return this.services[modelName].service.insertDataQuery();
  },
  deleteData(modelName) {
    return this.services[modelName].service.deleteDataQuery();
  },
  getByMyId(modelName, params) {
    return this.services[modelName].service.getByMyIdQuery(params);
  },
};
